import { AuditStationPage } from '@app/modules/audit/modules/station-audit/components/AuditStationPage';
import { StationScheduleStatusPage } from './StationScheduleStatusPage';

/**
 * Wraps the schedule status page in the audit station layout for station-scoped audit routes.
 */
export function AuditScheduleStatusPageAdapter() {
  return (
    <AuditStationPage>
      <StationScheduleStatusPage />
    </AuditStationPage>
  );
}
